import { useCallback } from 'react';
import { useTranslation } from '../../../utils/useTranslation';
import { WithHint } from '../../feedback/Tooltip';
import { Input } from '../../input/Input';
import { makeTextSuggest } from '../../input/makeTextSuggest';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';
import { Wrapper } from './styles';
import { GeoSuggestFieldProps } from './types';

const InputWithSuggest = makeTextSuggest(Input);

const formatText = (_key: string, value: string) => value;

export const GeoSuggestField: React.FC<GeoSuggestFieldProps> = ({
    value,
    selected,
    suggests,
    withHint,
    required,
    onSelect,
    onRemove,
    onInput,
    ...other
}) => {
    const t = useTranslation();

    const suggest = suggests.reduce<Record<string, string>>(
        (res, item) => ({ ...res, [item.id]: item.name }),
        {},
    );

    const onSelectItem = useCallback(
        (key: string) => {
            onSelect({ [key]: suggest[key] });
        },
        [suggest, onSelect],
    );

    return (
        <Wrapper {...other}>
            <Flex direction="row" alignItems="center">
                <Typography variant="title3" weight="bold">
                    {t('География показов')}
                </Typography>
                {withHint ? (
                    <WithHint
                        ml={1}
                        iconColor="var(--color-secondary)"
                        message={t('Выберите регион, где хотели бы продвигать ваши посты')}
                    />
                ) : null}
            </Flex>
            <Box pt={2} width="100%">
                <InputWithSuggest
                    value={value}
                    variant="outline"
                    placeholder={t('Введите или выберите из списка')}
                    empty={t('Ничего не найдено')}
                    width={250}
                    withFind={false}
                    suggest={suggest}
                    selectedItems={selected}
                    onSelectItem={onSelectItem}
                    onRemoveItem={onRemove}
                    onInputSuggest={onInput}
                    formatSuggestText={formatText}
                    formatSelectedText={formatText}
                    required={required}
                    disableCloseOnScroll
                />
            </Box>
        </Wrapper>
    );
};
